export default __webpack_public_path__ + "static/media/calconvert_logo.6f54fc9c.svg";